/** @jsxImportSource @emotion/react */
import { createFetchContext } from '../contextFetch/FetchContext'
import { MenuServiceItemsType } from './types'

export default createFetchContext<MenuServiceItemsType>()
